var map = {
	"./AssessmentReport.svg": 8191,
	"./Daily.svg": 7782,
	"./EnrolledPatientReport.svg": 1837,
	"./Failed.svg": 7160,
	"./Ghana.svg": 6176,
	"./HF.svg": 2205,
	"./Info-blue.svg": 6264,
	"./Info-green.svg": 8813,
	"./Kenya.svg": 9229,
	"./MOH.svg": 7777,
	"./PatientDuplicateReport.svg": 495,
	"./PatientStatusReport.svg": 9730,
	"./Pending.svg": 560,
	"./Permanent.svg": 6971,
	"./Presc.svg": 3048,
	"./ScreenedReport.svg": 1154,
	"./Sierra Leone.svg": 1550,
	"./Spice.svg": 1307,
	"./SpiceEngage.svg": 3710,
	"./Tanzania.svg": 9394,
	"./UserPerformance.svg": 6336,
	"./arrow-right-small.svg": 9717,
	"./assignQuickSightUser.svg": 5805,
	"./avatar-o.svg": 8016,
	"./bin.svg": 5646,
	"./caret-down-grey.svg": 1763,
	"./caret-down-white.svg": 7993,
	"./checkbox-disabled.svg": 4513,
	"./checkbox-empty.svg": 9536,
	"./checkbox.svg": 5884,
	"./close.svg": 7733,
	"./download.svg": 9359,
	"./dropdown.svg": 4156,
	"./edit.svg": 6343,
	"./hf1.svg": 6822,
	"./hf2.svg": 3461,
	"./hf3.svg": 5476,
	"./hf4.svg": 3179,
	"./hf7.svg": 7640,
	"./hidePass.svg": 4644,
	"./home.svg": 4278,
	"./info-grey.svg": 8573,
	"./info-orange.svg": 5162,
	"./insights.svg": 7892,
	"./no-icon.svg": 9972,
	"./plus.svg": 1363,
	"./power-switch.svg": 6843,
	"./quickSightUser.svg": 3298,
	"./reports.svg": 2476,
	"./reset.svg": 868,
	"./search.svg": 1599,
	"./send-disabled.svg": 8838,
	"./send.svg": 4505,
	"./showPass.svg": 5075,
	"./success-blue.svg": 181,
	"./success-green.svg": 5182,
	"./tick.svg": 9104,
	"./user-role-assigned.svg": 888,
	"./user-role-not-assigned.svg": 4012,
	"./warning.svg": 4137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;